import type { FC, ReactNode } from 'react'

import { useSmoothScroll } from '@/components/generals/smooth-scroll'

// The MACHGO mark starts in the middle of the cabin window and is flown up into the
// header by the hero scene, which finds it through data-flying-wordmark.
const FlyingWordmark: FC = (): ReactNode => {
    const { scrollTo } = useSmoothScroll()

    return (
        <div
            data-flying-wordmark
            className='pointer-events-none fixed inset-x-0 top-1/2 z-[60] -mt-[0.5em] flex justify-center text-[clamp(1.9rem,3.4vw,3.6rem)] leading-none will-change-transform'
        >
            <a
                href='#hero'
                onClick={(event) => {
                    event.preventDefault()
                    scrollTo(0)
                }}
                aria-label='MACHGO, back to the top'
                className='pointer-events-auto pl-[0.32em] font-heading font-medium tracking-[0.32em] text-[var(--header-ink)] transition-colors duration-500 focus-visible:outline focus-visible:outline-1 focus-visible:outline-offset-8 focus-visible:outline-champagne'
            >
                MACHGO
            </a>
        </div>
    )
}

export default FlyingWordmark
